import { TestingContextPageScopeProvider } from "@/flokit/utils/testing-context/page-scope";
import kebabCase from "lodash/kebabCase";
import lowerCase from "lodash/lowerCase";
import Head from "next/head";
import { useEffect } from "react";
import { enforceTitle } from "./enforce-title/state";

export default function PageWrapper({
  children,
  title = "Flo Recruit",
  unrestrictViewport = false,
}: {
  children: React.ReactNode;
  title?: string;
  unrestrictViewport?: boolean;
}) {
  useEffect(() => {
    enforceTitle.title = title;
    return () => {
      enforceTitle.title = null;
    };
  }, [title]);

  return (
    <>
      <Head>
        <title>{title}</title>
        {unrestrictViewport && (
          <meta
            name="viewport"
            content="width=device-width, initial-scale=1, maximum-scale=5"
          />
        )}
      </Head>
      <TestingContextPageScopeProvider scope={kebabCase(lowerCase(title))}>
        {children}
      </TestingContextPageScopeProvider>
    </>
  );
}
